import { useEffect, useState } from "react";
import { DatePickerInputNew, Input, MultiSelect } from "../../../Helpers/Input/Input";
import { useSelector } from "react-redux";
import { toLocalISOString } from "../../../../JsHelpers/DateFormat";
import trans from "../../../../utils";
import { useLazyGetUserGroupQuery } from "../../../../Redux/service/Groups/Groups";
import { useLazyGetDevicesByGroupQuery } from "../../../../Redux/service/Groups/GroupsBack";
import { Tag } from "antd";
import { useLocation } from "react-router-dom";

export default function ReportSheetsInput({
	setStartDate,
	setEndDate,
	selectedVehicles,
	setSelectedVehicles,
	startDate,
	endDate,
	isShown,
	setStart,
	setEnd,
	setItems,
	start,
	end,
	items,
	selectedGroupId,
	setSelectedGroupId,
	dueWithin,
	setDueWithin,
	shouldRefetchGroups,
}) {
	const inf = useSelector((state) => state.users.user);
	const [triggerGetUserGroups, { data: UserGroups, isLoading }] =
		useLazyGetUserGroupQuery();
	const [options, setOptions] = useState([]);
	const [Groupsoptions, setGroupsOptions] = useState([]);
	const [triggerGetDevicesByGroup] = useLazyGetDevicesByGroupQuery();
	const [loadingDevices, setLoadingDevices] = useState(false);
	const { pathname } = useLocation();
	const getShortPath = () => pathname.split("/").pop();
	const shortPath = getShortPath();

	useEffect(() => {
		if (shouldRefetchGroups && inf?.id) {
			triggerGetUserGroups(inf?.id);
		}
	}, [shouldRefetchGroups, inf?.id, triggerGetUserGroups]);

	useEffect(() => {
		const fetchAllVehicles = async () => {
			if (selectedGroupId?.length > 0) {
				setLoadingDevices(true);
				const allDevices = [];

				// Fetch each group’s vehicles
				for (const groupId of selectedGroupId) {
					try {
						const result = await triggerGetDevicesByGroup(groupId).unwrap();
						allDevices.push(...result);
					} catch (err) {
						console.error("Error fetching vehicles for group:", groupId, err);
					}
				}
				// Remove duplicate vehicles by ID (optional)
				const uniqueDevices = Array.from(
					new Map(allDevices.map((item) => [item.id, item])).values()
				);
				const formattedOptions = uniqueDevices.map((i) => ({
					value: i.id,
					label: (
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								gap: "8px",
							}}
						>
							<span>{i.name}</span>
							<Tag color="green">{i.groupName || "Ungrouped  Vehicles"}</Tag>
						</div>
					),
					text: i.name,
				}));
				setOptions(formattedOptions);
				setLoadingDevices(false);
			} else {
				setOptions([]);
			}
		};

		fetchAllVehicles();
	}, [selectedGroupId]);

	useEffect(() => {
		if (UserGroups) {
			const formattedOptions = [
				{ label: trans("Ungrouped  Vehicles"), value: 0 },
				...UserGroups.map((i) => ({
					value: i.id,
					label: i.name,
				})),
			];
			setGroupsOptions(formattedOptions);
		}
	}, [UserGroups]);

	const handleDateRangeChange = ({ startDate, endDate }) => {
		setStart(startDate ? toLocalISOString(new Date(startDate)) : null);
		setEnd(endDate ? toLocalISOString(new Date(endDate)) : null);
	};

	useEffect(() => {
		setStart("");
		setEnd("");
		setItems([]);
	}, [setEnd, setItems, setStart]);

	useEffect(() => {
		if (isShown === true) {
			setStartDate(start);
			setEndDate(end);
			setSelectedVehicles(items);
			console.log("Selected Vehicles:", selectedVehicles);
		}
	}, [isShown]);

	const handleGChange = (value) => {
		setSelectedGroupId(value);
	};

	const handleVChange = (value) => {
		setItems(value);
		console.log("Selected Vehicles:", value);
	};

	return (
		<div>
			<MultiSelect
				title={trans("Group")}
				options={Groupsoptions}
				multi={true}
				onChange={handleGChange}
				isloading={isLoading}
				placeholder={trans("Select Group")}
			/>
			<MultiSelect
				title={trans("Vehicles")}
				options={options}
				multi={shortPath === "route" ? false : true}
				onChange={handleVChange}
				isloading={loadingDevices}
				placeholder={trans("Select Vehicle")}
			/>
			{shortPath !== "maintenance" && (
				<DatePickerInputNew
					id="dateRange"
					name="dateRange"
					title={trans("Date Range")}
					formstyle="form-input"
					onChange={handleDateRangeChange}
					value={{ startDate, endDate }}
				/>
			)}
			{shortPath === "maintenance" && (
				<Input
					title={trans("Due Within (days)")}
					type="number"
					placeholder={trans("Enter days")}
					formstyle="form-input"
					value={dueWithin}
					min={0}
					onChange={(e) => setDueWithin(e.target.value)}
				/>
			)}
		</div>
	);
}
